import {AbstractReactComponent, ff, i18n, Icon} from 'mc/lib';
import {Form, FormActions, FormBody} from 'mc/lib/form';
import {requireFields} from 'mc/lib/utils';
import PropTypes from 'prop-types';
import React from 'react';
import {toastr} from 'react-redux-toastr';
import {Alert, Button} from 'reactstrap';
import {propTypes, reduxForm, SubmissionError} from 'redux-form';
import {Api} from '../../api';
import {getQueryParams} from "../../utils";

function showErrorMessage(errorTypeText, message) {
    if (message && message.length > 0) {
        toastr.error(errorTypeText, message, {timeOut: 100000});
    } else {
        toastr.error(errorTypeText, null, {timeOut: 100000});
    }
}

const validateRequiredFields = requireFields(['username', 'password']);

class LoginForm extends AbstractReactComponent {

    static formName = 'login';

    static propTypes = {
        onLogin: PropTypes.func.isRequired,
        onLostPassword: PropTypes.func.isRequired,
        ...propTypes,
    };

    static validate = values => {
        return validateRequiredFields(values);
    };

    constructor(props) {
        super(props);
        this.state = {openidConfigured: false};
    }

    componentDidMount() {
        Api.isOpenIdConfigured().then((configured) => configured.text().then(message => {
            let configured = message === "true";
            this.setState({openidConfigured: configured});
        }));
    }

    onSubmitOpenId = () => {
        Api.loginByOpenId();
    };

    onSubmit = data => Api.login(data.username, data.password).then((response) => {
        response.text().then(data => {
            if (data === "true") {
                this.props.onLogin();
                window.location.reload(true);
            } else {
                this.setState({error: i18n('loginForm.invalidLogin')})
            }
        })
    });

    render() {
        const {error, handleSubmit, submitting} = this.props;
        const openidConfigured = this.state.openidConfigured;
        const errorLogin = this.state.error;

        return <Form onSubmit={handleSubmit(openidConfigured ? this.onSubmitOpenId : this.onSubmit)}>
            <FormBody>
                <h3 className="text-center">{i18n('loginForm.title')}</h3>
                {error && <Alert color="danger">{error}</Alert>}
                {errorLogin && <Alert color="danger">{errorLogin}</Alert>}
                {!openidConfigured && <ff.String name="username" label={false} placeholder={i18n('loginForm.username')} autoComplete="off" required />}
                {!openidConfigured && <ff.String name="password" label={false} type="password" placeholder={i18n('loginForm.password')} autoComplete="off" required/>}
                {!openidConfigured && <div className="text-right">
                    <Button color="link" onClick={this.props.onLostPassword}>{i18n('loginForm.lostPassword')}</Button>
                </div>}
            </FormBody>
            <FormActions>
                <Button color="primary" block className="login" type="submit" disabled={submitting}>{submitting ? <Icon icon="spinner" animation={Icon.animation.spin}/> : null} {i18n('loginForm.submit')}</Button>
            </FormActions>
        </Form>
    }
}

const formConfig = {
    form: LoginForm.formName,
    validate: LoginForm.validate
};

export default reduxForm(formConfig)(LoginForm);
